import { ReactNode } from "react";

import Title from "./Title";

const Section = ({
  id,
  title,
  className,
  children,
  gradient = false,
}: SectionProps) => (
  <section id={id} aria-labelledby={`${id}Section`} className={className}>
    {title && (
      <Title id={`${id}Section`} gradient={gradient}>
        {title}
      </Title>
    )}
    {children}
  </section>
);

interface SectionProps {
  id?: string;
  title?: string;
  className?: string;
  children?: ReactNode;
  gradient?: boolean;
}

export default Section;
